import type { QueriesObject, QueryResults, System } from '../../odie';

import TaskQueue from '../../lib/pattern/TaskQueue';
import { BlockComponent } from '../components/BlockComponent';
import { DogBlockComponent } from '../components/DogBlockComponent';
import { DogBlockEntity } from '../entities/BlockEntity';
import type { GameScene } from '../GameScene';
import { DogEffect } from '../actions/effects/DogEffect';

/*
    handles dog block specifics
*/
export class DogBlockSystem implements System {
  // constants
  //-------------------------------------------------------------------------
  public static readonly NAME = 'blockDog';
  public static Queries: QueriesObject = {
    block: {
      components: [BlockComponent, DogBlockComponent],
    },
    removed: {
      components: [BlockComponent],
      removed: true,
    },
  };

  // fields
  //-------------------------------------------------------------------------
  // injected
  public scene?: GameScene;
  public queries!: QueryResults;
  // state
  private _activateQueue: TaskQueue = new TaskQueue();

  // impl
  //-------------------------------------------------------------------------
  public removedFromQuery() {
    this.scene?.sessionEntity.c.phase.activePush();
    // handle basic block cleared
    this.queries.block.forEach((entity: DogBlockEntity) =>
      this._activateDog(entity),
    );
    this._activateQueue.add(async () => {
      this.scene?.sessionEntity.c.phase.activePop();
    });
  }

  // private: actions
  //-------------------------------------------------------------------------
  private async _activateDog(entity: DogBlockEntity) {
    // add to queue
    this._activateQueue.add(async () => {
      // Scene already destroyed.
      if (!this.scene) return;
      // play effect
      await new DogEffect(this.scene, { subject: entity }).execute();
    });
  }
}
